import { useMemo } from 'react';
import { 
  FaUserMd, 
  FaSyringe, 
  FaFire, 
  FaBoxOpen, 
  FaQuestionCircle 
} from 'react-icons/fa';

export const useCategoryRender = () => {
  return useMemo(
    () => (category: string) => {
      const categoryConfigs: Record<
        string,
        { text: string; color: string; icon: React.ReactNode }
      > = {
        CONSULTATION: {
          text: 'Consultation',
          color: 'blue',
          icon: <FaUserMd />,
        },
        TREATMENT: {
          text: 'Treatment',
          color: 'green',
          icon: <FaSyringe />,
        },
        LHR: {
          text: 'LHR',
          color: 'volcano',
          icon: <FaFire />,
        },
        PACKAGE: {
          text: 'Package',
          color: 'purple',
          icon: <FaBoxOpen />,
        },
        OTHER: {
          text: 'Other',
          color: 'default',
          icon: <FaQuestionCircle />,
        },
      };

      return (
        categoryConfigs[category] || {
          text: category || 'Unknown',
          color: 'default',
          icon: <FaQuestionCircle />,
        }
      );
    },
    []
  );
};
